import { render, staticRenderFns } from "./customerMgtAdmin.vue?vue&type=template&id=2e68964c&scoped=true&"
import script from "./customerMgtAdmin.vue?vue&type=script&lang=js&"
export * from "./customerMgtAdmin.vue?vue&type=script&lang=js&"
import style0 from "./customerMgtAdmin.vue?vue&type=style&index=0&id=2e68964c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68964c",
  null
  
)

export default component.exports